<template>
  <div>
    <Modal v-model="show" title="积分配置" width="1200" :footer-hide="true">
      <loading :isShow="loading" />
      <div class="space-box">
        <Form ref="myForm" :model="formData" class="page-form" inline :label-width="140">
          <FormItem label="积分规则" style="width: 20%">
            <span v-if="formData.configType == 1">按缴费期留比例</span>
            <span v-else-if="formData.configType == 2">按缴费期留点</span>
          </FormItem>
          <FormItem class="info" style="width: 77%" :label-width="20">
            <template v-if="formData.configType == 1">
              <div>按缴费期留比例:转介人及其下游按照不同的缴费期留取不同的占比。</div>
              <div>
                如:一级转介人某个缴费期产品总积分为90%,一级转介人留10%的占比,二级转介人5%的占比,那么三级转介人出该缴费期的保单时,他应得的积分为90%*(100%-10%-5%)。
              </div>
            </template>
            <template v-else-if="formData.configType == 2">
              <div>按缴费期留点:转介人及转介人下游按照不同的缴费期留取不同的积分点。</div>
              <div>
                如:一级转介人某个缴费期产品总积分为90%,一级转介人留10%的积分点,二级转介人5%的积分点,那么三级转介人出该缴费期的保单时,他应得的积分为90%-10%-5%。
              </div>
            </template>
          </FormItem>
          <table border="1" class="table-content" border-color="#eee">
            <tr>
              <td>产品名称</td>
              <td>缴费期</td>
              <td v-for="(year, index) in years" :key="index">{{ year.name }}</td>
            </tr>
            <tr v-for="(item, index) in formData.rateRuleList" :key="index">
              <td :rowspan="formData.rateRuleList.length" v-if="index == 0">{{ formData.productName }}</td>
              <td>{{ item.paymentPeriod | filterPaymentPeriod }}</td>
              <td v-for="(rate, idx) in item.rateList" :key="idx">
                {{ item.rateList[idx] }}
              </td>
            </tr>
          </table>
        </Form>
      </div>
    </Modal>
  </div>
</template>

<script>
const dic = JSON.parse(localStorage.dic); // 排序的字典 数组结构
export default {
  components: {
  },
  filters: {
    filterPaymentPeriod(v) {
      return `${dic.PAYMENT_INT[v]}`;
    },
  },
  props: {
    params: null
  },
  data() {
    return {
      loading: false,
      data: {},
      formData: {
        id: '',
        productId: '',
        tenantId: '',
        configType: '',	 //积分配置规则 1按缴费期留比例 2按缴费期留点
        rateRuleList: []
      },
      userId: "", //用户id
      show: false,
      rulesList: [
        {
          name: '按缴费期留比例',
          value: '1',
        },
        {
          name: '按缴费期留点',
          value: '2',
        },
      ],
      years: [
        {
          name: '首年(%)',
        },
        {
          name: '第二年(%)',
        },
        {
          name: '第三年(%)',
        },
        {
          name: '第四年(%)',
        },
        {
          name: '第五年(%)',
        },
      ]

    };
  },

  methods: {
    changeCommission(data, pidx, idx) {
      let rate = data.target.value
      if (rate > 100) {
        this.$set(this.formData, `rateRuleList[${pidx}].rateList[${idx}]`, 100)
        this.formData.rateRuleList[pidx].rateList[idx] = 100;
      } else if (rate < 0) {
        this.$set(this.formData, `rateRuleList[${pidx}].rateList[${idx}]`, 0)
        this.formData.rateRuleList[pidx].rateList[idx] = 0;
      }
    },
    open(data = {}) {
      this.show = true;
      this.$refs.myForm.resetFields();
      this.data = JSON.parse(JSON.stringify(data))
      this.getDetail();//编辑
    },
    getDetail() {
      console.log(this.data)
      this.loading = true;
      let params = {}
      if (this.data.id) {
        params.id = this.data.id
      } else {
        params.tenantId = this.data.tenantId
        params.productId = this.data.productId
      }
      this.$http({
        url: this.data.id ? '/buz/merchantProductCommissionConfig/queryDetail' : '/buz/merchantProductCommissionConfig/queryAdd',
        type: this.data.id ? 'GET' : 'POST',
        data: params
      }).then(res => {
        this.formData = res.data;
        this.formData.tenantId = this.data.tenantId;
        this.formData.productId = this.data.productId;
      }).finally(() => {
        this.loading = false;
      })
    },
    onOK() {
      this.$refs.myForm.validate().then(isok => {
        if (!isok) {
          return;
        }
        this.loading = true;
        let data = JSON.parse(JSON.stringify(this.formData))
        this.$http({
          url: this.data.id ? '/buz/merchantProductCommissionConfig/edit' : '/buz/merchantProductCommissionConfig/add',
          type: 'POST',
          data: data
        }).then(res => {
          console.log(res)
          this.$notice.success('操作成功');
          this.$emit('success')
          this.show = false;
        }).finally(() => {
          this.loading = false;
        })
      })
    }
  }
};
</script>

<style lang="scss" scoped>
.footer-btn {
  display: flex;
  justify-content: center;
}
.ok-btn {
  margin-left: 15px;
}
.table-content {
  border-color: #e8eaec;
  width: 100%;
  text-align: center;
  table-layout: fixed;
  td {
    padding: 10px;
    /deep/.ivu-input {
      margin: 10px 0;
      width: calc(100% - 20px);
    }
  }
}
.info {
  color: #666;
  margin-right: 0px;
  padding-right: 0px;
}
</style>
